import { GET_COUNTRIES_API } from "../utils/api";

export const LOAD_COUNTRIES_REQUEST = "@countries/LOAD_COUNTRIES_REQUEST";
export const LOAD_COUNTRIES_SUCCESS = "@countries/LOAD_COUNTRIES_SUCCESS";
export const LOAD_COUNTRIES_FAILLURE = "@countries/LOAD_COUNTRIES_FAILLURE";
export const LOAD_COUNTRY = "@countries/LOAD_COUNTRY";

export function loadCountries() {
  return async (dispatch) => {
    try {
      dispatch({ type: LOAD_COUNTRIES_REQUEST });
      const response = await GET_COUNTRIES_API();
      dispatch({
        type: LOAD_COUNTRIES_SUCCESS,
        payload: {
          countries: response?.data?.data?.countries,
          activeCountry: response?.data?.data?.activeCountry,
        },
      });
    } catch (error) {
      dispatch({
        type: LOAD_COUNTRIES_FAILLURE,
      });
    }
  };
}
